const FILTER_COLOUR_SWATCHES = {
  animal: { pattern: "animal" },
  black: { color: "#000000" },
  blue: { color: "#326fda" },
  brown: { color: "#6e4730" },
  gold: { color: "#d4af37" },
  green: { color: "#5c6752" },
  grey: { color: "#8a8a8a" },
  gray: { color: "#8a8a8a" },
  ivory: { color: "#f5f5f0", border: true },
  metallic: {
    gradient:
      "linear-gradient(90deg, #595e66 0%, #d9dbe0 28%, #fafafc 49%, #7a8087 64%, #ccd1d6 100%)",
  },
  multi: {
    gradient:
      "linear-gradient(90deg, #e03840 0%, #f5b833 25%, #40a657 50%, #3373d9 75%, #a647b8 100%)",
  },
  natural: { color: "#c9c4b5" },
  navy: { color: "#1e3a8a" },
  nude: { color: "#f2d7c4" },
  orange: { color: "#e18836" },
  pink: { color: "#de62a1" },
  purple: { color: "#7742a6" },
  red: { color: "#d32f2f" },
  silver: { color: "#b1b1b1" },
  white: { color: "#ffffff", border: true },
  yellow: { color: "#f7dc6f" },
};

export function isColourFilterName(name) {
  const label = String(name || "")
    .trim()
    .toLowerCase();

  return label === "colour" || label === "color";
}

export function getFilterColourSwatch(label) {
  const key = String(label || "")
    .trim()
    .toLowerCase();

  return FILTER_COLOUR_SWATCHES[key] || { color: "#d9d9d9" };
}
